// extracted by mini-css-extract-plugin
export default {"input":"Search_input__j50ZT","btn":"Search_btn__L3xTr"};